interface SaveBeforeEmployeeChangeProps {
  /**
   * Правила формы, как у кнопки «Сохранить». При ошибке — отклонённый
   * промис, antd показывает ошибку под полем.
   */
  validate(): Promise<unknown>;
  /** Сохранение записи (onFinish) */
  save(): Promise<unknown>;
  /** Переход на вкладку другого исполнителя */
  selectEmployee(): void;
}

/**
 * «Сохранить» в окне несохранённых данных при смене вкладки исполнителя.
 * onFinish сам правила формы не проверяет: без проверки количество услуги
 * с абонемента больше предела ушло бы в UpdateRecord (task/11536). При
 * ошибке правил запись не сохраняется и вкладка не меняется. true — запись
 * сохранена.
 */
export const saveBeforeEmployeeChange = async ({
  validate,
  save,
  selectEmployee,
}: SaveBeforeEmployeeChangeProps): Promise<boolean> => {
  try {
    await validate();
  } catch {
    // Ошибки правил antd уже показал под полями: пользователь исправит их
    // и сохранит снова.
    return false;
  }

  await save();
  selectEmployee();

  return true;
};
